module.exports = __webpack_public_path__ + "static/media/tent.7d6b3a96.svg";